<div *ngIf="showConfirmation">
    <p>{{ 'thank-you-for-booking-ticket-qcloud-system' | translate }}!</p>
    <h5>
        {{ 'save-take-code-to-appointment' | translate }}:
        <span class="text-primary">{{ ticketReservation.code }}</span>
    </h5>
    <div class="alert alert-info my-2">
        <i class="fas fa-info-circle"></i>
        {{ 'necessary-code' | translate }}. {{ 'schedule-time' | translate }}.
    </div>

    <div>{{ 'your-reserved-ticket' | translate }}:</div>
    <div>{{ 'category' | translate }}: <span class="text-primary font-weight-bold">{{ categoryName }}</span></div>
    <div>{{ 'date' | translate }}:
        <span class="text-primary font-weight-bold">
            {{ displayReservationTime | date:'dd/MM/yyyy HH:mm' }}
        </span>
    </div>
</div>
<div *ngIf="!showConfirmation">
    <p>{{ 'confirm-reservation' | translate }}</p>
    <div class="alert alert-info my-2">
        <i class="fas fa-info-circle"></i>
        {{ 'confirm-time' | translate }} {{ confirmationTime }} min. {{ 'confirmation-time-exceeded' | translate }}.
    </div>
</div>